import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const addImagesStatusSelector = (state: State) => state.addImages.status;
export const addImagesIdSelector = (state: State) => state.addImages.entities;
export const addImagesLoadedSelector = isLoaded(addImagesStatusSelector);
export const shouldLoadaddImagesSelector = shouldLoad(addImagesStatusSelector);
export const addImagesRejectedSelector = isRejected(addImagesStatusSelector);
export const addImagesPendingSelector = isPending(addImagesStatusSelector);
